import * as stylex from '@stylexjs/stylex';
import _ from 'lodash';

import { useTranslation } from 'react-i18next';
import { RemovableTextButton } from '@/core/RemovableTextButton.molecule';
import { Button } from '@seeqdev/qomponents';
import type { Datasource } from '@/search/search.types';

interface ActiveFiltersProps {
  selectedFilters: { label: string; filter: string | string[] | Datasource[]; onClear: () => void }[];
  actionAfterFilterCleared?: () => void;
}

export const ActiveFilters = ({ selectedFilters, actionAfterFilterCleared = _.noop }: ActiveFiltersProps) => {
  const { t } = useTranslation();

  const activeFilters = _.reject(selectedFilters, ({ filter }) => _.isEmpty(filter));

  if (activeFilters.length === 0) {
    return <></>;
  }

  return (
    <div data-testid="activeFilters" {...stylex.props(styles.filters)}>
      {t('SEARCH_DATA.FILTERS')}
      {_.map(activeFilters, ({ label, onClear }) => (
        <Button
          key={label}
          testId={label}
          label={
            <RemovableTextButton
              label={label}
              showFormat={true}
              onClick={() => {
                onClear();
                actionAfterFilterCleared();
              }}
            />
          }
        />
      ))}
    </div>
  );
};

export const styles = stylex.create({
  filters: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 5,
    marginBottom: '0.625rem',
    alignItems: 'center',
  },
});
